import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d5b927e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "locations" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate" }, "All Locations", -1))
const _hoisted_4 = { class: "dt-container" }
const _hoisted_5 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "You haven't added any locations yet.", -1))
const _hoisted_7 = { class: "inventory-table__actions d-flex flex-column flex-sm-row align-items-sm-end mb-4" }
const _hoisted_8 = { class: "me-sm-2 mb-4 mb-sm-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Easily manage receivers by assigning them a location.", -1))
const _hoisted_10 = { class: "order-3 order-sm-0 mt-4 mt-sm-1" }
const _hoisted_11 = { class: "ms-sm-auto" }
const _hoisted_12 = { class: "px-1" }
const _hoisted_13 = { class: "d-flex flex-row mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Sublocations: ", -1))
const _hoisted_15 = { class: "el-tooltip__list" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "d-flex flex-row mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Rooms: ", -1))
const _hoisted_19 = { class: "d-flex flex-row mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Receivers: ", -1))
const _hoisted_21 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_22 = ["d"]
const _hoisted_23 = { class: "el-tooltip__list" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_26 = ["d"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/locations/new' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("New Location")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.loading && _ctx.locationSearchResults.length == 0 && !_ctx.locationSearch && !_ctx.searchDebounce)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              class: "mt-3 d-inline-block",
              to: { path: '/locations/new'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "px-3 py-2 px-sm-5 py-sm-3",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add Your First Location")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_tooltip, {
                    disabled: _ctx.selectedLocationIds.length > 0,
                    content: "Select locations to delete.",
                    "close-delay": "0",
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: _normalizeClass(["my-0", { 'is-disabled' : _ctx.selectedLocationIds.length < 1 }]),
                        onClick: _ctx.massDeleteLocations
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Delete")
                        ]),
                        _: 1
                      }, 8, ["class", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_input, {
                  placeholder: "Search Locations",
                  modelValue: _ctx.locationSearch,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.locationSearch) = $event)),
                  onKeyup: _ctx.handleFilterChange
                }, null, 8, ["modelValue", "onKeyup"])
              ])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.processedLocations,
              ref: "locationsTable",
              style: {"width":"100%"},
              onCellClick: _ctx.handleCurrentChange,
              onSortChange: _ctx.sortTable,
              onSelectionChange: _ctx.handleSelectionChange,
              "default-sort": _ctx.defaultSort,
              key: _ctx.defaultSortKey
            }, {
              default: _withCtx(() => [
                (_ctx.windowWidth.value < 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "expand",
                      width: "55"
                    }, {
                      default: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            (props.row.subLocationNames && props.row.subLocationNames.length > 0)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  placement: "top-start",
                                  title: ""
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("ul", _hoisted_15, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.subLocationNames, (subLocationName, i) => {
                                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(subLocationName), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(props.row.subLocationNames.length), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, "0"))
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", null, _toDisplayString(props.row.roomCount), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("div", null, _toDisplayString(props.row.deviceCount), 1)
                          ]),
                          _createVNode(_component_el_button, {
                            disabled: _ctx.saving,
                            class: "mt-4 mb-3 el-table-row__delete-button el-table-row__delete-button--mobile",
                            type: "danger",
                            id: props.row.id,
                            onClick: ($event: any) => (_ctx.deleteLocationClick(props.row)),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock("svg", _hoisted_21, [
                                _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_22)
                              ]))
                            ]),
                            _: 2
                          }, 1032, ["disabled", "id", "onClick"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Name",
                  sortable: "custom"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_router_link, {
                      to: `/locations/${scope.row.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 1
                }),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      prop: "subLocationCount",
                      label: "Sublocations",
                      sortable: "custom"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.subLocationNames && scope.row.subLocationNames.length > 0)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              placement: "top-start",
                              title: "",
                              width: 200
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("ul", _hoisted_23, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.subLocationNames, (subLocationName, i) => {
                                    return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(subLocationName), 1))
                                  }), 128))
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(scope.row.subLocationNames.length), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, "0"))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      prop: "roomCount",
                      label: "Rooms",
                      sortable: "custom"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 3,
                      prop: "deviceCount",
                      label: "Receivers",
                      sortable: "custom"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 4,
                      prop: "id",
                      "class-name": "el-table-row__delete"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          disabled: _ctx.saving,
                          class: "el-table-row__delete-button",
                          type: "danger",
                          id: scope.row.id,
                          onClick: ($event: any) => (_ctx.deleteLocationClick(scope.row)),
                          circle: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("svg", _hoisted_25, [
                              _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_26)
                            ]))
                          ]),
                          _: 2
                        }, 1032, ["disabled", "id", "onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data", "onCellClick", "onSortChange", "onSelectionChange", "default-sort"])), [
              [_directive_loading, !_ctx.processedLocations]
            ]),
            _hoisted_27,
            _createVNode(_component_el_pagination, {
              class: "d-flex justify-content-center",
              background: "",
              layout: "prev, pager, next, slot",
              total: _ctx.locationCount,
              "page-size": _ctx.paging.pageSize,
              onCurrentChange: _ctx.handleCurrentPageChange,
              onSizeChange: _ctx.handleSizeChange,
              "current-page": _ctx.paging.pageIndex,
              "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paging.pageIndex) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_select, {
                    onChange: _ctx.handleSizeChange,
                    "model-value": _ctx.paging.pageSize,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "10 per page",
                        value: 10
                      }),
                      _createVNode(_component_el_option, {
                        label: "50 per page",
                        value: 50
                      }),
                      _createVNode(_component_el_option, {
                        label: "100 per page",
                        value: 100
                      }),
                      _createVNode(_component_el_option, {
                        label: "500 per page",
                        value: 500
                      }),
                      _createVNode(_component_el_option, {
                        label: "All",
                        value: 100000
                      })
                    ]),
                    _: 1
                  }, 8, ["onChange", "model-value"])
                ])
              ]),
              _: 1
            }, 8, ["total", "page-size", "onCurrentChange", "onSizeChange", "current-page"])
          ], 64))
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}